import React, { Component } from 'react'
import { mapProps } from 'recompose'
import * as R from 'ramda'

import {
  Input,
  withReducer,
  withConnect,
} from 'containers/Form/Input'
import {
  getValueSelector
} from 'containers/Form/Input/selectors'
import {
  withValidationSagas as validationSagas,
  withValidationError,
  withFormValidation
} from 'containers/Form/Validation/index'
import validations from './validations'
import withSagas from './sagas'

const withValidation = withValidationError(validations)
const withValidationSagas = validationSagas(validations)
const doNotTypeE = (evt) => evt.key === 'e' && evt.preventDefault()

export default R.curry((path, id, validation) => R.compose(
  mapProps((props) => ({...props, type: 'number', onKeyDown: doNotTypeE })),
  withReducer(path, id),
  withConnect(path, id),
  withSagas(path, id),
  withFormValidation(path, id, validation),
)(Input))
